const YM_ID = 105420810;

export const YM = {
  RESET: "widget_home_reset_click",
  COPY: "widget_home_copy_click",
  REFERRAL_COPY: "referral_link_copy_click",
  REFERRAL_QR_DOWNLOAD: "referral_qr_download_click",
  REFERRAL_PRINT: "referral_print_click",
} as const;

export type YmEvent = (typeof YM)[keyof typeof YM];

export function ymEvent(event: YmEvent, params?: Record<string, unknown>): void {
  if (typeof window === "undefined" || !window.ym) return;
  window.ym(YM_ID, "reachGoal", event, params);
}
